import React from "react";

/**
 * RVR: Report, Verify and Remedial Action.
 *
 * The canonical list. Home and About each carried their own copy of this array
 * (`STEPS` and `RVR_STEPS`), byte-identical down to the punctuation, with a
 * comment on the Home one asking whoever edited it to keep the two in sync by
 * hand. They are one array now, so they cannot drift.
 */
export const RVR_STEPS = [
  {
    icon: "fas fa-bullhorn",
    title: "Report",
    body: "Upload a photo, video, or voice clip with a short description of any suspicious product or service and submit a report via the app.",
  },
  {
    icon: "fas fa-search",
    title: "Verify",
    body: "Reports are reviewed by brands, regulators, or the BLEEP team. Once assessed, they are marked as Ongoing or Verified.",
  },
  {
    icon: "fas fa-gavel",
    title: "Remedial Action",
    body: "Verified cases may trigger product recalls, seizures, investigations, or enforcement. You'll receive updates at every step.",
  },
];

/**
 * The three steps drawn as a connected route rather than three loose cards.
 *
 * An `<ol>`, because the whole point is that these happen in order: the markup
 * said "three columns" while the copy said "first, then, then". The nodes sit on
 * a dashed track that runs across them on a wide screen and down the left of
 * them on a narrow one, so the sequence survives the breakpoint instead of
 * becoming a stack of unrelated blurbs.
 */
const RvrRoadmap = () => (
  <ol className="home-road">
    {RVR_STEPS.map((step, i) => (
      <li
        className="home-road__step"
        key={step.title}
      >
        <span className="home-road__node">
          <i
            className={step.icon}
            aria-hidden="true"
          />
          <span
            className="home-road__num"
            aria-hidden="true"
          >
            {i + 1}
          </span>
        </span>
        <div className="home-road__body">
          <h3 className="home-road__title">{step.title}</h3>
          <p className="home-road__line">{step.body}</p>
        </div>
      </li>
    ))}
  </ol>
);

export default RvrRoadmap;
